<template>
  <router-view/>

  <toast-container />
</template>

<script>
import { defineAsyncComponent } from 'vue'
const ToastContainer = defineAsyncComponent(() => import(/* webpackPrefetch: true */ '@/global/Toast'))

export default {
  components: {
    'toast-container': ToastContainer
  }  
}
</script>

<style lang="sass">
@mixin font($fname, $fstyle, $fweight, $furl)
  @font-face
    font-family: $fname
    font-style: $fstyle
    font-weight: $fweight
    // font-display: swap // Uncomment to initially display system fonts
    src: local($fname), url($furl) format('woff2')

// @include font('Lato', normal, 100, './assets/fonts/Lato/Lato-Thin.woff2')
@include font('Lato', normal, 200, './assets/fonts/Lato/Lato-Light.woff2')
@include font('Lato', normal, 300, './assets/fonts/Lato/Lato-Regular.woff2')
@include font('Lato', normal, 500, './assets/fonts/Lato/Lato-Medium.woff2')
@include font('Lato', normal, 700, './assets/fonts/Lato/Lato-Bold.woff2')
@include font('Lato', normal, 800, './assets/fonts/Lato/Lato-Black.woff2')

@include font('License', normal, 400, './assets/fonts/LicensePlate/LicensePlate.ttf')

#app
  font-family: 'Lato', sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: left
  scroll-behavior: smooth
  text-rendering: optimizeLegibility
  padding: 0
  margin: 0

body
  margin: 0
  padding: 0

</style>
